export default {
    state: {
        snack: '',
        snacktype: ''
    },
    getters: {

    },
    mutations: {
        SET_SNACK : (state,payload) => {
            state.snack = payload
        },
        SET_SNACKTYPE : (state,payload) => {
            state.snacktype = payload
        }
    },
    actions: {

    }
}